/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

/**
 * Fetch Talon One rewards/inventory for a customer
 * @param {string} contactId - Customer contact ID
 * @param {string} jwtToken - JWT Access Token
 * @param {object} params - Optional query parameters
 * @returns {Promise} - API response
 */
const fetchTalonOneRewards = async ({ contactId, jwtToken, params = {} }) => {
    const wcEnv = {
        rootUri: '/retention/pf/',
    };

    const defaultParams = {
        pageSize: 10,
        page: 1,
        profile: true,
        ...params,
    };

    const resourcePath = `talon_one/v1/customer_profiles/${contactId}/inventory?loyalty=true&t=${Date.now()}`;

    const response = await restClient.getFacade(
        wcEnv,
        resourcePath,
        jwtToken,
        defaultParams,
        null,
        false, // don't add brand param
    );

    return response;
};

export default fetchTalonOneRewards;
